const firebaseConfig = {
  apiKey: "AIzaSyBT62CW6Y5sOb9eD5dx_b2Vls-Ur97UjdA",
  authDomain: "boighor-da35b.firebaseapp.com",
  projectId: "boighor-da35b",
  storageBucket: "boighor-da35b.appspot.com",
  messagingSenderId: "831348047590",
  appId: "1:831348047590:web:1d6f06236d78d0d49cc527"
};
  export default firebaseConfig;